import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import type { IGlobalStoreReducers } from './ReduxStore';

export interface IStampDialogState {
    visible: boolean;
}

const initialState: IStampDialogState = {
    visible: false,
};

const reducers = {
    update: (state: IStampDialogState, action: PayloadAction<boolean>) => {
        state.visible = action.payload;
    },
};

export const stampDialogSlice = createSlice({
    name: 'stampDialog',
    initialState,
    reducers,
});

export const stampDialogVisibility = (state: IGlobalStoreReducers) => state.stampDialog.visible;

export const { update } = stampDialogSlice.actions;

export default stampDialogSlice.reducer;
